export default __webpack_public_path__ + "conversationsEmpty.svg";